import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ConfigService} from './config.service';
import {AuthLogin} from './authLogin';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private translate: TranslateService, config: ConfigService, oauth: AuthLogin) {
    translate.setDefaultLang('de');
    translate.use('de');
  //  console.log('okay je suis la ', localStorage.getItem('partnerId'),  localStorage.getItem('user'));
    config.configure();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts